export enum ResolveResultKindEnum {
  Org = 'org',
  Master = 'master',
  Error = 'error'
}
